import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountRoutingModule } from './account-routing.module';
import { LoginComponent } from './login/login.component';

import { QuillModule } from 'ngx-quill';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { NamedloginComponent } from './namedlogin/namedlogin.component';
import { ChangeAccountPasswordComponent } from './change-account-password/change-account-password.component';
import { UserLinkFormComponent } from './login/user-link-form/user-link-form.component';
import { CompanyInputComponent } from './login/company-input/company-input.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { KioskloginComponent } from './kiosklogin/kiosklogin.component';
import { PasswordInputComponent } from '../../shared/component/password-input/password-input.component';

@NgModule({
  declarations: [
    LoginComponent,
    NamedloginComponent,
    ChangeAccountPasswordComponent,
    UserLinkFormComponent,
    CompanyInputComponent,
    CreateAccountComponent,
    KioskloginComponent,
    PasswordInputComponent,
  ],
  imports: [CommonModule, AccountRoutingModule, QuillModule, FormsModule, ReactiveFormsModule, SharedModule],
})
export class AccountModule {}
